module.exports = __webpack_public_path__ + "img/Tosee.1dfe4086.svg";